import {Core} from '@hybird/core/bridge/core'
import {WebError} from '@hybird/core/error'
import {deviceError} from '@hybird/device/deviceError'
import {bridge} from "./dsBridge"

const listen = []
window.callHandlerResult = (name, data) => {
  for (const i in listen) {
    listen[i].call(null, name, data)
  }
}

class OhosBridge extends Core {

  constructor() {
    super()

    this._readyFn.push(() => {
      this.invoke('flutterReady', {}, {})
    })

    if (window._dsbridge) {
      this._isReady = true
      this._readyFn.forEach((fn) => fn())
    } else {
      setTimeout(() => {
        if (window._dsbridge) {
          this._readyFn.forEach((fn) => fn())
        }
      }, 200);
    }

    this.on('removeEventListener', (params) => {
      this.off(params.name, {topic: params.topic})
    }, {isOne: true})
  }

  async invoke(name, params, {namespace = '', on = {}}) {
    await super.invoke(name, params, {namespace})

    if (this.isSupport()) {
      let result = await new Promise((resolve, reject) => {
        bridge.call(this.parseName(name, namespace), params, (result) => {
          resolve(result);
        })
      })

      if (result) {
        if (result.code === 0) {
          for (const event in result.event) {
            if (typeof on[event] === 'function') {
              this.on(event, on[event], {params, topic: result.event[event]})
            }
          }
          const method = {}

          for (const event in result.method) {
            if (typeof on[event] === 'function') {
              method[event] = (params) => {
                return this.invoke(result.method[event], params, {namespace})
              }
            }
          }

          result.method = method

          return result.data
        } else {
          throw WebError.code(deviceError.INVOKE_ERROR, {
            data: result, msg: result.errMsg
          })
        }
      }

      return result
    } else {
      throw WebError.code(deviceError.FLUTTER_INIT_ERROR)
    }
  }

  async on(name, event, {
    topic = name, params = {}, filter = () => true, namespace = '', isOne = false, isSend = false, off
  } = {}) {
    const eventName = this.parseName(name, namespace)
    await super.on(eventName, event, {
      topic, params, filter, namespace, isOne, isSend
    })

    if (isSend) {
      await this.invoke(eventName, params, {namespace})
    }

    this._addEventFn(name, event, {topic, filter, isOne})

    return {
      cancel: this.off.bind(this, name, {
        event, namespace, topic, isSend, off, params
      })
    }
  }

  flutterOn(event, params, {topic = event}) {
    const fns = this._getEventFn(event, {isOne: false})
    const results = []

    fns.events
            ?.filter((value) => value.topic === topic)
            .forEach((fn) => {
              try {
                results.push({
                  data: fn.event.call(fn, params), isOne: fn.isOne, success: true
                })
              } catch (e) {
                console.error(`处理${event}时出现异常, ${JSON.stringify(params)}, ${e}`)

                results.push({
                  isOne: fn.isOne, success: false
                })
              }
            })

    return results.find((value) => value.success && value.isOne)
  }

  async off(id, {event, namespace, params = {}, topic, isSend = false, off}) {
    this._removeEventFn(id, {event, topic})

    if (isSend) {
      await this.invoke(off, params, {namespace})
    }
  }

  ready(event) {
    super.ready(event)

    return new Promise((resolve) => {
      const fn = () => {
        resolve()
        event()
      }

      //当flutter好后, 再次调用直接回调方法
      if (this._isReady) {
        fn()
      } else {
        this._readyFn.push(fn)
      }
    })
  }

  isSupport() {
    return !!window._dsbridge
  }
}

export {OhosBridge}
